import {
  LO_ID,
  MOSCOW_AND_MOSCOW_AREA_ID,
  MOSCOW_AREA_ID,
  MOSCOW_ID,
  SPB_AND_LO_ID,
  SPB_ID,
} from '../../../../constants/geo';
import { IRegion } from '../../../../types/regions';
import { isMoscowAndMoscowArea, isMoscowOrMoscowArea, isSBPOrLo, isSPBAndLo } from '../../../../utils/geo';

export function getSpecialMainCities(currentRegion: IRegion, regionsById: Map<number, IRegion>): IRegion[] | null {
  const region = currentRegion.parentId ? regionsById.get(currentRegion.parentId) : currentRegion;

  if (isMoscowAndMoscowArea(region) || isMoscowOrMoscowArea(region)) {
    return [
      regionsById.get(MOSCOW_AND_MOSCOW_AREA_ID),
      regionsById.get(MOSCOW_AREA_ID),
      regionsById.get(MOSCOW_ID),
    ] as IRegion[];
  }

  if (isSPBAndLo(region) || isSBPOrLo(region)) {
    return [regionsById.get(SPB_AND_LO_ID), regionsById.get(LO_ID), regionsById.get(SPB_ID)] as IRegion[];
  }

  return null;
}
